import _ from 'lodash';
import moment from 'moment';
import { Component, ReactElement } from 'react';
import { connect } from 'react-redux';
import { Media } from '../../../../../../shared/frontend/components/presentational/media';
import { createActionSetError, TError } from '../../../../../../shared/frontend/scripts/actions/errorActions';
import { getSeasonBySlug } from '../../../../shared/enums';
import { withSiteMeta } from '../../../../../../shared/frontend/HOCS/withSiteMeta';
import WorldFirstTrackerActions from '../../actions/worldFirstTrackerActions';
import RecruitmentPane, { TRecruitmentPaneProps } from '../presentational/recruitment/recruitmentPane';
import { Upsell } from '../../../../../../shared/frontend/components/upsells';
import { FatedRaidsPane, TFatedRaidsPaneProps } from './base-main-page-components/fatedRaidsPane';
import { FeaturedStreamsPane, TFeaturedStreamsPaneProps } from './base-main-page-components/featuredStreams';
import { InContentAd } from '../../../../../../shared/frontend/components/ads/inContentAd';
import { ThinLeaderboardAd } from '../../../../../../shared/frontend/components/ads/thinLeaderboardAd';
import {
  MythicPlusRecentRunsPane,
  TMythicPlusRecentRunsPaneProps
} from './base-main-page-components/mythicPlusRecentRunsPane';
import { MythicPlusTeamsPane, TMythicPlusTeamsPaneProps } from './base-main-page-components/mythicPlusTeamsPane';
import { TMythicPlusTopAffixRunsPaneProps } from './base-main-page-components/mythicPlusTopAffixRunsPane';
import { MythicPlusTopPlayers, TMythicPlusTopPlayersProps } from './base-main-page-components/mythicPlusTopPlayers';
import { NewsPane, TNewsPaneProps } from './base-main-page-components/newsPane';
import { RaidDuoPane, TRaidDuoPaneProps } from './base-main-page-components/raidDuoPane';
import {
  RaidExpansionHistoryPane,
  TRaidExpansionHistoryPaneProps
} from './base-main-page-components/raidExpansionHistoryPane';
import { RaidPartitionsPane, TRaidPartitionsPaneProps } from './base-main-page-components/raidPartitionsPane';
import type { TRWFVisualizerPaneProps } from './base-main-page-components/rwfVisualizerPane';
import { SiteDescription, TSiteDescriptionProps } from './base-main-page-components/siteDescription';
import { MythicPlusTopRunsPane, TMythicPlusTopRunsPaneProps } from './base-main-page-components/mythicPlusTopRunsPane';
import { TAction } from '../../../../../../shared/frontend/scripts/actions/types/action';
import {
  ITopILvlAndAchievementsSectionProps,
  TopILvlAndAchievementsSection
} from './base-main-page-components/TopILvlAndAchievementsSection';
import { RemixSection, TRemixSectionProps } from './base-main-page-components/remixSection';
import loadable from '@loadable/component';

const RWFVisualizerPane = loadable(() => import('./base-main-page-components/rwfVisualizerPane'));

type TPropsFromState = {
  siteConfig: any;
  siteMeta: any;
  currentFeatures: any;
};

type TPropsThatDispatch = {
  setWorldFirstTracker(actionData: any): void;
  showError(actionData: TError): void;
  showLoadingSpinner(show: boolean): void;
  forceRefresh(): void;
};

export type THomeContentProps = {
  includeDescription?: TSiteDescriptionProps;
  includeMythicPlusTopPlayers?: TMythicPlusTopPlayersProps;
  includeRaidDuo?: TRaidDuoPaneProps;
  includeSecondaryRaidDuo?: TRaidDuoPaneProps;
  includeMythicPlusTeams?: TMythicPlusTeamsPaneProps;
  includeFatedRaids?: TFatedRaidsPaneProps;
  includeFeaturedStreams?: TFeaturedStreamsPaneProps;
  includeRWFVisualizer?: TRWFVisualizerPaneProps;
  includeRaidPartitions?: TRaidPartitionsPaneProps;
  includeRaidExpansionHistory?: TRaidExpansionHistoryPaneProps;
  includeNews?: TNewsPaneProps;
  includeRecruitment?: TRecruitmentPaneProps;
  includeMythicPlusRecentRuns?: TMythicPlusRecentRunsPaneProps;
  includeMythicPlusTopAffixRuns?: TMythicPlusTopAffixRunsPaneProps;
  includeMythicPlusTopRuns?: TMythicPlusTopRunsPaneProps;
  includeTopItemLevelAndAchievement?: ITopILvlAndAchievementsSectionProps;
  includeRemix?: TRemixSectionProps;
};

type THomeContentComponentProps = THomeContentProps & TPropsFromState & TPropsThatDispatch;

export type TSpecClassParams = {
  classSlug: string;
  specSlug: string;
};

export type TClassParams = {
  classSlug: string;
};

/**
 * HomeContent
 */
class HomeContentBase extends Component<THomeContentComponentProps> {
  public render(): ReactElement<THomeContentComponentProps> {
    const now = moment.utc();
    // const isRaidOpen = now >= RAID_METADATA_BY_SLUG['nerubar-palace'].starts.us;
    const isSeasonOpen = now >= getSeasonBySlug('season-tww-1').starts.us;
    const desktopHeaderAd = ['mediavine', 'aditude'].includes(this.props.siteConfig.displayAdsProvider) ? (
      <ThinLeaderboardAd />
    ) : null;

    return (
      <>
        {this.props.includeFeaturedStreams?.enabled && (
          <FeaturedStreamsPane
            // hiddenWhenSmall={!!this.props.currentFeatures.rwf_live}
            {...this.props.includeFeaturedStreams}
          />
        )}

        {this.props.includeRWFVisualizer?.enabled && <RWFVisualizerPane {...this.props.includeRWFVisualizer} />}

        {desktopHeaderAd}

        {this.props.includeDescription?.enabled && (
          <SiteDescription className="slds-m-top--large rio-hidden--small" {...this.props.includeDescription} />
        )}

        <Media greaterThan="sm">
          <Upsell className="slds-m-top--large" />
        </Media>

        {/* {this.props.currentFeatures.ads_header_swap && this.props.siteConfig.displayAdsProvider === 'playwire' && (
            <TakeoverStatus when="inactive">
              <ZoneContainer
                tag="section"
                className="slds-text-align--center rio-hidden--small slds-p-around--x-small"
                type="header"
              />
            </TakeoverStatus>
          )} */}

        {this.props.includeNews?.enabled && <NewsPane {...this.props.includeNews} />}

        {this.props.includeRecruitment?.enabled && <RecruitmentPane {...this.props.includeRecruitment} />}

        <InContentAd />

        {this.props.includeRemix?.enabled && <RemixSection {...this.props.includeRemix} />}

        {this.props.includeRaidDuo?.enabled && <RaidDuoPane {...this.props.includeRaidDuo} />}

        {this.props.includeSecondaryRaidDuo?.enabled && <RaidDuoPane {...this.props.includeSecondaryRaidDuo} />}

        {this.props.includeRaidPartitions?.enabled && <RaidPartitionsPane {...this.props.includeRaidPartitions} />}

        {this.props.includeRaidExpansionHistory?.enabled ||
          (this.props.includeFatedRaids?.enabled && (
            <>
              <InContentAd at="sm" />
              <FatedRaidsPane {...this.props.includeFatedRaids} />
            </>
          ))}

        {this.props.includeRaidExpansionHistory?.enabled && (
          <RaidExpansionHistoryPane {...this.props.includeRaidExpansionHistory} />
        )}

        {this.props.includeFatedRaids?.enabled && <FatedRaidsPane {...this.props.includeFatedRaids} />}

        {isSeasonOpen && <InContentAd />}

        {this.props.includeTopItemLevelAndAchievement?.enabled && (
          <TopILvlAndAchievementsSection {...this.props.includeTopItemLevelAndAchievement} />
        )}

        {this.props.includeMythicPlusTopPlayers?.enabled && (
          <MythicPlusTopPlayers {...this.props.includeMythicPlusTopPlayers} />
        )}

        {isSeasonOpen && <InContentAd at="sm" />}

        {this.props.includeMythicPlusTopRuns?.enabled && (
          <MythicPlusTopRunsPane {...this.props.includeMythicPlusTopRuns} />
        )}

        {isSeasonOpen && <InContentAd at="sm" />}

        {this.props.includeMythicPlusTeams?.enabled && <MythicPlusTeamsPane {...this.props.includeMythicPlusTeams} />}

        {isSeasonOpen && <InContentAd />}

        {this.props.includeMythicPlusRecentRuns?.enabled && (
          <MythicPlusRecentRunsPane {...this.props.includeMythicPlusRecentRuns} />
        )}

        <Upsell className="slds-m-top--large slds-m-bottom--small" seedOffset={1} />
      </>
    );
  }
}

// take state from store and convert into props
function mapStateToProps(state: any): TPropsFromState {
  return {} as any;
}

// return props that need access to `dispatch` function (props that can modify the store?)
function mapDispatchToProps(dispatch: Function, ownProps: THomeContentComponentProps): TPropsThatDispatch {
  return {
    setWorldFirstTracker(rankings: any) {
      dispatch(WorldFirstTrackerActions.setWorldFirstTracker(rankings));
    },
    showError(actionData: TError) {
      dispatch(createActionSetError(actionData));
    },
    showLoadingSpinner(show: boolean) {
      dispatch(WorldFirstTrackerActions.showLoadingSpinner(show));
    },
    forceRefresh() {
      dispatch(WorldFirstTrackerActions.forceRefresh());
    }
  };
}

export const HomeContent = withSiteMeta(
  connect<TPropsFromState, TPropsThatDispatch, THomeContentComponentProps>(
    mapStateToProps,
    mapDispatchToProps
  )(HomeContentBase as any)
);

(HomeContent as any).preloadComponentActions = async (
  contentParams: THomeContentProps,
  params: any
): Promise<TAction<any>[]> => {
  const promises: any[] = [];

  if (contentParams.includeNews?.enabled) {
    promises.push((NewsPane as any).preloadComponentActions(contentParams.includeNews, params));
  }

  if (contentParams.includeRecruitment?.enabled) {
    promises.push((RecruitmentPane as any).preloadComponentActions(contentParams.includeRecruitment, params));
  }

  if (contentParams.includeFatedRaids?.enabled) {
    promises.push((FatedRaidsPane as any).preloadComponentActions(contentParams.includeFatedRaids, params));
  }

  if (contentParams.includeRaidPartitions?.enabled) {
    promises.push((RaidPartitionsPane as any).preloadComponentActions(contentParams.includeRaidPartitions, params));
  }

  if (contentParams.includeRaidExpansionHistory?.enabled) {
    promises.push(
      (RaidExpansionHistoryPane as any).preloadComponentActions(contentParams.includeRaidExpansionHistory, params)
    );
  }

  if (contentParams.includeRaidDuo?.enabled) {
    promises.push((RaidDuoPane as any).preloadComponentActions(contentParams.includeRaidDuo, params));
  }

  if (contentParams.includeSecondaryRaidDuo?.enabled) {
    promises.push((RaidDuoPane as any).preloadComponentActions(contentParams.includeSecondaryRaidDuo, params));
  }

  // NOTE: RWFVisualizerPane is lazy-loaded, so preloadComponentActions is not accessible
  // on the React.lazy wrapper. The component will load its data on mount instead.

  if (contentParams.includeFeaturedStreams?.enabled) {
    promises.push((FeaturedStreamsPane as any).preloadComponentActions(contentParams.includeFeaturedStreams, params));
  }

  if (contentParams.includeMythicPlusTopPlayers?.enabled) {
    promises.push(
      (MythicPlusTopPlayers as any).preloadComponentActions(contentParams.includeMythicPlusTopPlayers, params)
    );
  }

  if (contentParams.includeMythicPlusTeams?.enabled) {
    promises.push((MythicPlusTeamsPane as any).preloadComponentActions(contentParams.includeMythicPlusTeams, params));
  }

  if (contentParams.includeRemix?.enabled) {
    promises.push((RemixSection as any).preloadComponentActions(contentParams.includeRemix, params));
  }

  if (contentParams.includeMythicPlusRecentRuns?.enabled) {
    promises.push(
      (MythicPlusRecentRunsPane as any).preloadComponentActions(contentParams.includeMythicPlusRecentRuns, params)
    );
  }

  if (contentParams.includeMythicPlusTopRuns?.enabled) {
    promises.push((MythicPlusTopRunsPane as any).preloadComponentActions(contentParams.includeMythicPlusTopRuns));
  }

  if (contentParams.includeTopItemLevelAndAchievement?.enabled) {
    promises.push(
      TopILvlAndAchievementsSection.preloadComponentActions(contentParams.includeTopItemLevelAndAchievement, params)
    );
  }

  const results = await Promise.allSettled(promises);
  return _.flatten(
    results
      .filter((result): result is PromiseFulfilledResult<any[]> => result.status === 'fulfilled')
      .map((result) => result.value)
  );
};
